
<template>
  <div class="d-flex align-center justify-center"> 
    <span>{{ webNotes }}</span>
    <v-btn
      icon
      @click="startEditingDialog()"
    >
      <v-icon>{{ webNotes ? 'mdi-pencil' : 'mdi-plus' }} </v-icon>
  </v-btn>
  </div>
</template>
<script>
const { VUE_APP_GATEWAY_HOST } = process.env;

import { makeFetchRequest } from '../../utils';
import { EventBus } from '../../mixins'

import dayjs from "dayjs";
// import advancedFormat from 'dayjs/plugin/advancedFormat';
// dayjs.extend(advancedFormat);

export default {
  props: {
    webNotes: {
      type: String,
      default: null
    },
    updatedItem: {
      type: Object,
      default: null
    }
  },
  methods: {
    async setWebNotes() {
      this.$emit('toggle-loading');

      const dateString = dayjs.utc(this.updatedItem.date).format("DD-MM-YYYY");

      const body = {
        query: `mutation iresaSetWebNotes($packageCode: Int!, $date: String!, $webNotes: String!, $idPartner: Int!, $marque: Int!) { 
          iresaSetWebNotes(packageCode: $packageCode, date: $date , webNotes: $webNotes, idPartner: $idPartner, marque: $marque) { 
            success message data 
          }
        }`,
        variables: {
          packageCode: parseInt(this.updatedItem.packageCode),
          date: dateString,
          webNotes: this.updatedItem.value,
          idPartner: 1, // TEMP TO LABALAGEURE
          marque: 2
        }
      }

      const notification = {
          type: 'success'
      };

      // Mutation to save min depart guarantee
      await makeFetchRequest(VUE_APP_GATEWAY_HOST, 'POST', body).then(() => {
        notification.message = "Web Notes enregistrée";
        this.$emit('set-items-new-value');
      }).catch(err => {
        console.log("WebNotes ERR: ", err)  
        notification.type = "danger";
        notification.message = "Une erreur s'est produite";
      });

      this.$emit('toggle-loading');
      this.$emit('reset-dialog');
      
      EventBus.$emit('show-notifications', [notification]);
    },
    startEditingDialog() {
      this.$emit('start-editing-dialog', this.setWebNotes);
    }
  }
};
</script>
